export default __webpack_public_path__ + "static/media/public-auctions.9b6b1417.jpg";